import { render, staticRenderFns } from "./OptionsCategories.vue?vue&type=template&id=32f670e8"
import script from "./OptionsCategories.vue?vue&type=script&lang=js"
export * from "./OptionsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports